export const environment = {
    production: true,
    defaultLang: 'es-ES',
    backEndDomain: window.location.origin + '/',
    STRIPE_KEY: "pk_live_W3zbPrqt56FtR9E58LQRAn35",
    master_domain: "https://www.myrubric.com",
    sentry_dist: ""

};
